import { render, staticRenderFns } from "./SwitchObservador.vue?vue&type=template&id=4f7c1bde&scoped=true"
import script from "./SwitchObservador.vue?vue&type=script&lang=js"
export * from "./SwitchObservador.vue?vue&type=script&lang=js"
import style0 from "./SwitchObservador.vue?vue&type=style&index=0&id=4f7c1bde&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c1bde",
  null
  
)

export default component.exports